const HAS_SCHEME = /^[a-z][a-z0-9+.-]*:\/\//i;
const HOST_WITH_PATH = /^[a-z0-9.-]+\.[a-z]{2,}(?::\d+)?\//i;

const isNeonHost = (host: string) =>
    host === 'neon.markets' ||
    host.endsWith('.neon.markets') ||
    host === 'svc-neon.markets' ||
    host.endsWith('.svc-neon.markets');

const isLocalHost = (host: string) =>
    host === 'localhost' || host === '127.0.0.1' || host === '[::1]';

export const normalizeImageUrl = (src?: string | null) => {
    const value = src?.trim();
    if (!value) return value;

    if (value.startsWith('data:') || value.startsWith('blob:')) {
        return value;
    }

    if (value.startsWith('//')) {
        try {
            const url = new URL(`http:${value}`);
            return `${isLocalHost(url.hostname) ? 'http:' : 'https:'}${value}`;
        } catch {
            return `https:${value}`;
        }
    }

    if (HOST_WITH_PATH.test(value)) {
        return `https://${value}`;
    }

    if (!HAS_SCHEME.test(value)) {
        return value;
    }

    try {
        const url = new URL(value);

        if (isLocalHost(url.hostname) && url.protocol === 'https:') {
            url.protocol = 'http:';
            return url.toString();
        }

        if (url.protocol === 'http:' && isNeonHost(url.hostname)) {
            url.protocol = 'https:';
            return url.toString();
        }
    } catch {
        return value;
    }

    return value;
};

export const normalizeImageSourcesInHtml = (html: string) => {
    if (!html || typeof DOMParser === 'undefined') return html;

    const document = new DOMParser().parseFromString(html, 'text/html');

    document.querySelectorAll<HTMLImageElement>('img[src]').forEach((image) => {
        const src = image.getAttribute('src');
        const normalizedSrc = normalizeImageUrl(src);

        if (normalizedSrc && normalizedSrc !== src) {
            image.setAttribute('src', normalizedSrc);
        }
    });

    return document.body.innerHTML;
};
